/* eslint-disable max-lines */
import {CHECKOUT_TYPES} from 'constants/checkout';

export type StaticRouteType = {
    url: string;
    page: string;
    params: {dyType: string};
    event?: string;
};

export const staticUrls = [
    {url: '/', page: 'home', event: 'viewHome', params: {dyType: 'HOMEPAGE'}},
    {
        url: '/checkout/onepage',
        page: 'checkout',
        params: {dyType: 'OTHER', type: CHECKOUT_TYPES.DEFAULT},
    },
    {
        url: '/optimaxcheckout/amazon',
        page: 'checkout',
        params: {dyType: 'OTHER', type: CHECKOUT_TYPES.AMAZON},
    },
    {url: '/checkout/cart', page: 'cart', params: {dyType: 'CART'}, event: 'viewBasket'},
    {
        url: '/checkout/onepage/success',
        page: 'successPage',
        event: 'trackTransaction',
        params: {dyType: 'OTHER'},
    },
    {url: '/customer/account', page: 'profile', params: {type: 'dashboard', dyType: 'OTHER'}},
    {url: '/sales/order/history', page: 'profile', params: {type: 'orderHistory', dyType: 'OTHER'}},
    {
        url: '/customer/account/edit',
        page: 'profile',
        params: {type: 'accountEdit', passwordEdit: false, dyType: 'OTHER'},
    },
    {
        url: '/customer/account/edit/changepass/1',
        page: 'profile',
        params: {type: 'accountEdit', passwordEdit: true, dyType: 'OTHER'},
    },
    {url: '/customer/address/new', page: 'profile', params: {type: 'addressNew', dyType: 'OTHER'}},
    {url: '/review/customer', page: 'profile', params: {type: 'customerReview', dyType: 'OTHER'}},
    {
        url: '/customer/address/form',
        page: 'profile',
        params: {type: 'addressEdit', dyType: 'OTHER'},
    },
    {
        url: '/customer/address/index',
        page: 'profile',
        params: {type: 'addressesList', dyType: 'OTHER'},
    },
    {
        url: '/customer/account/changeforgotten',
        page: 'resetPassword',
        params: {dyType: 'OTHER'},
    },
    {url: '/salesperson/result', page: 'searchResults', params: {dyType: 'OTHER'}},
    {url: '/scan', page: 'sixOverSix', params: {dyType: 'OTHER'}},
    {url: '/contacts', page: 'contacts', params: {dyType: 'OTHER'}},
    {url: '/rma', page: 'rma', params: {dyType: 'OTHER'}},
    {
        url: '/checkout/cart/configure/id/:id',
        page: 'productEdit',
        params: {dyType: 'PRODUCT'},
    },
    {
        url: '/blog/:post',
        page: 'blogPost',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/blog',
        page: 'blog',
        params: {dyType: 'OTHER'},
    },
    {url: '/customer/address/edit/id/:id', page: 'profile', params: {dyType: 'OTHER'}},
    {url: '/sales/order/view/order_id/:orderId', page: 'profile', params: {dyType: 'OTHER'}},
    {
        url: '/sales/order/invoice/order_id/:orderId',
        page: 'profile',
        params: {dyType: 'OTHER'},
    },
    {url: '/sales/order/shipment/order_id/:orderId', page: 'profile', params: {dyType: 'OTHER'}},
    {
        url: '/sales/order/printInvoice/invoice_id/:invoiceId',
        page: 'profile',
        params: {dyType: 'OTHER'},
    },
    {url: '/tracking/search', page: 'orderSearch', params: {dyType: 'OTHER'}},
    {url: '/home-try-on', page: 'hto', params: {dyType: 'OTHER'}},
    {url: '/review/product/list/id/:id', page: 'addReview', params: {dyType: 'OTHER'}},
    {
        url: '/checkout/prescription',
        page: 'uploadPrescription',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/pairfect_match',
        page: 'pairfectMatch',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/vision-insurance',
        page: 'insuranceLP',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/insurance/:company',
        page: 'insuranceLP',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/limited-time-offer-enhanced-coverage/:orderId',
        page: 'postPurchaseInsurance',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/wishlist',
        page: 'wishlist',
        params: {dyType: 'OTHER'},
    },
    {
        url: '/quiz-results',
        page: 'quizResults',
        params: {dyType: 'OTHER'},
    },
];

export const dynamicRoutes = {
    product: {
        page: 'product',
        params: {dyType: 'PRODUCT'},
    },
    category: {
        page: 'category',
        params: {dyType: 'CATEGORY'},
    },
    page: {
        page: 'page',
        params: {dyType: 'OTHER'},
    },
    error404: {
        page: 'error404',
        params: {dyType: 'OTHER'},
    },
} as const;
